import React, { useEffect, useState } from "react";
import chromePic from "../../../../../assets/images/chrome.png";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { isEmpty } from "lodash";
import { CustomTooltip } from "../../Dashboard/DashboardGraph/ScreenTime";
import {
  blockActivity,
  deleteActivity,
  getWebActivity,
} from "../../../AxiosRtk/DashBoard";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ScreenshotsFilter from "../../modals/ScreenshotsFilter";
import {
  handleStartDate,
  handleStartDateCommon,
} from "../../../../../utils/helper";
// import Swal from "sweetalert2";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import useDurationOption from "../../../../customHooks/durationOption";
import Select from "react-select";
import LoadingIndicator from "../../../../../setup/Loader/LoaderIndicator";
import { setAppData } from "../../../AxiosRtk/DashBoard";
import DateFilter from "../../../../shared/DateFilter/DateFilter";

const WebActivityScreen = ({ selectedDeviceId, getLangTranslation }) => {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState([]);
  const [bars, setBars] = useState([]);
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  // const [selectedDeviceId, setSelectedDeviceId] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [webGraphActivities, setWebGraphActivities] = useState([]);
  const [webActivities, setWebActivities] = useState([]);
  const [totalUsedTime, setTotalUsedTime] = useState();
  const [filterData, setFilterData] = useState(null);
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const { selectedKidId, selectedDeviceData, appData } = useSelector(
    ({ dashboard }) => dashboard
  );
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(webActivities.map((item) => item.ID));
    }
    setSelectAll(!selectAll);
  };
  const handleCheckboxClick = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  useEffect(() => {
    const barMap = new Map();
    const graphBarMap = new Map();
    webGraphActivities?.forEach((item) => {
      if (
        item?.categoryName &&
        item?.color &&
        !barMap?.has(item?.categoryName?.split(" ")[0])
      ) {
        barMap?.set(item?.categoryName?.split(" ")[0], item?.color);
      }
      if (graphBarMap.has(Number(item?.hour) + 1)) {
        const obj = { ...graphBarMap.get(Number(item?.hour) + 1) };
        if (obj[item?.categoryName?.split(" ")[0]]) {
          obj[item?.categoryName?.split(" ")[0]] =
            +obj[item?.categoryName?.split(" ")[0]] + +item?.duration;
        } else {
          obj[item?.categoryName?.split(" ")[0]] = item?.duration;
        }
        graphBarMap.set(Number(item?.hour) + 1, obj);
      } else {
        const tempObj = {
          name: Number(item?.hour) + 1,
          [item?.categoryName?.split(" ")[0]]: item?.duration,
        };
        graphBarMap.set(Number(item?.hour) + 1, { ...tempObj });
      }
    });

    const dataBarMap = Array.from(barMap, ([key, value]) => ({
      dataKey: key,
      fill: value,
    }));
    setBars(dataBarMap);
    const graphBarMapData = Array.from(graphBarMap, ([key, value]) => value);
    setGraphData(graphBarMapData);
  }, [webGraphActivities]);

  useEffect(() => {
    if (selectedDeviceId && startDate) {
      getWebActivityData();
    }
  }, [selectedDeviceId, startDate, filterData, endDate]);

  const getWebActivityData = () => {
    const filterDate = moment(startDate)
      .locale("en")
      .format("YYYY-MM-DD HH:mm:ss");
    const payload = {
      kidId: selectedKidId,
      deviceId: selectedDeviceId,
      activityType: "WEBSITE_VISITED",
      startDate: startDate,
      endDate: endDate,
      pageNo: 1,
      itemsPerPage: 20000,
    };

    let appPackageName = "";
    filterData?.appIds?.forEach((appId, index) => {
      appData?.forEach((appDataSet) => {
        if (appId === appDataSet?.appId) {
          if (index !== filterData?.appIds?.length - 1) {
            appPackageName = appPackageName + appDataSet?.appPackageName + ",";
          } else {
            appPackageName = appPackageName + appDataSet?.appPackageName;
          }
        }
      });
    });

    if (appPackageName) {
      payload["appPackageNames"] = appPackageName;
    }

    setLoader(true);
    getWebActivity(payload)
      .then((res) => {
        setWebGraphActivities(res?.data?.result?.websiteGraphData);
        setWebActivities(res?.data?.result?.websiteActivities);
        setTotalUsedTime(res?.data?.result?.totalUsedTime);
      })
      .catch((err) => {
        console.log(
          "web activity catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setAppData([]));
      });
  };

  const convertTime = (totalSec) => {
    if (!totalSec) {
      return `${0} hrs ${0} min ${0} sec`;
    }
    const hours = Math.floor(totalSec / 3600);
    const minutes = Math.floor((totalSec % 3600) / 60);
    const sec = (totalSec % 3600) % 60;
    return `${hours} hrs ${minutes} min ${sec} sec`;
  };
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const handleDelete = async () => {
    if (!isEmpty(selectedItems) || true) {
      const payload = {
        deviceId: selectedDeviceId,
        activityType: "WEBSITE_VISITED",
      };

      if (selectAll === 1) {
        payload["isDeleteAll"] = 1;
      } else {
        payload["webActivityId"] = selectedItems?.join(",");
      }

      // isDeleteAll: selectAll ? 1 : 0,
      // webActivityId: selectAll ? "" : selectedItems,
      try {
        const { data } = await deleteActivity(payload);
        if (data) {
          closeModal();
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: data?.message,
              message: data?.message,
            })
          );
          getWebActivityData();
        }
      } catch (error) {
        closeModal();
        console.log(error);
      }
    }
  };
  const handleBlock = () => {
    const selectedData = webActivities
      ?.filter((item) => selectedItems.includes(item?.ID))
      ?.map((item) => {
        return { name: item?.url, status: 1 };
      });
    const payload = {
      kidId: selectedKidId,
      kidDeviceId: selectedDeviceId || 0,
      browser_link: "",
      status: 1,
      browser_link_array: selectedData,
    };
    try {
      blockActivity(payload).then((res) => {
        if (res?.data?.status) {
          getWebActivityData();
          setSelectedItems([]);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleAllow = () => {
    const selectedData = webActivities
      ?.filter((item) => selectedItems.includes(item?.ID))
      ?.map((item) => {
        return { name: item?.url, status: 0 };
      });

    const payload = {
      kidId: selectedKidId,
      kidDeviceId: selectedDeviceId || 0,
      browser_link: "",
      status: 0,
      browser_link_array: selectedData,
    };
    try {
      blockActivity(payload).then((res) => {
        if (res?.data?.status) {
          getWebActivityData();
          setSelectedItems([]);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  return (
    <>
      {loader && (
        <>
          <LoadingIndicator height={20} width={100} />
          <div className="drawer-overlay" style={{ zIndex: "10" }}></div>
        </>
      )}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-6">
        {/* <h6 className="mb-0">
          {getLangTranslation("PERCENTAGE_FILTER", "Percentage (%)")}
        </h6>
        <span
          className={`form-check form-switch align-self-center mb-0 ${
            lang?.isRTL === 1 ? "ms-auto" : "me-auto"
          }`}
        >
          <input
            className="form-check-input cursor-pointer"
            id="deviceTime"
            type="checkbox"
            role="switch"
            defaultChecked
          />
          <label
            className="form-check-label text-blue-800 fw-semibold"
            htmlFor="deviceTime"
          >
            {getLangTranslation("WEB_COUNT", "Url count")}
          </label>
        </span> */}
        <div></div>
        <div className="d-inline-flex align-items-center gap-2">
          <span className="text-small text-gray">
            {getLangTranslation("CHILD_LOCATION_TODAY", "Today")}
          </span>
          <h3 className="text-blue-900 mb-0">{convertTime(totalUsedTime)}</h3>
        </div>
      </div>
      <div className="card-body">
        <div className="graph">

          <ResponsiveContainer width="100%" height={500}>
            <BarChart width={1000} height={500} data={graphData}>
              <CartesianGrid strokeDasharray="3 3" />
              {/* <XAxis dataKey="name" /> */}
              {/* <YAxis /> */}
              <YAxis label={{ value: getLangTranslation("PARENT_DASHBOARD_MINUTES", "minutes"), angle: -90, position: "insideLeft" }} />
              <Tooltip content={<CustomTooltip />} />
              <Legend />
              {bars?.map((item) => {
                return (
                  <Bar
                    dataKey={item?.dataKey?.split(" ")[0]}
                    stackId="a"
                    fill={item?.fill}
                    key={item?.fill}
                  />
                );
              })}
              <XAxis dataKey="name" label={{ value: getLangTranslation("PARENT_DASHBOARD_HOURS", "Hours"), position: "insideBottom", offset: -5 }} />

            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      {/* <img
        src={barGraph}
        className='w-100 mb-6'
        alt=""
      /> */}
      <ScreenshotsFilter
        showModal={showModal}
        closeModal={closeModal}
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <div className="d-flex align-items-center flex-wrap gap-3 mb-6">
        <div className="form-check form-switch">
          <input
            className="form-check-input cursor-pointer"
            id="enableScreenshot"
            type="checkbox"
            role="switch"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          <label
            className="form-check-label text-dark"
            htmlFor="enableScreenshot"
          >
            {getLangTranslation("MANAGE_NOTIFICATION_SELECT_ALL", "Select all")}
          </label>
        </div>
        <button
          className="btn btn-outline-primary"
          onClick={() => handleDelete()}
        >
          {getLangTranslation(
            "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
            "Delete selected"
          )}
        </button>
        <button
          className="btn btn-outline-success d-inline-flex align-items-center gap-1"
          onClick={handleAllow}
        >
          <i className="icon-check-fill success-icon fs-5" />{" "}
          {getLangTranslation("APP_WEB_CATEGORY_STATUS_ALLOWED", "Allow")}
        </button>
        <button
          className="btn btn-outline-danger d-inline-flex align-items-center gap-1 me-auto"
          onClick={handleBlock}
        >
          <i className="icon-ban danger-icon fs-5" />{" "}
          {getLangTranslation("APP_WEB_CATEGORY_STATUS_BLOCKED", "Block")}
        </button>
        {/*  <select
          className="form-select content-200 text-dark"
          id="country"
          aria-label="Default select example"
          name="date"
          onChange={(event) => handleStartDate(event, setStartDate)}
        >
          <option value="1">
            {getLangTranslation("CHILD_LOCATION_TODAY", "Today")}
          </option>
          <option value="2">
            {getLangTranslation("NUM_WEEK", "$NUM Week")?.replace("$NUM", 1)}
          </option>
          <option value="3">
            {getLangTranslation("NUM_WEEK", "$NUM Week")?.replace("$NUM", 2)}
          </option>
          <option value="4">
            {getLangTranslation("NUM_MONTH", "$NUM Month")?.replace("$NUM", 1)}
          </option>
          <option value="5">
            {getLangTranslation("PARENT_TASK_FILTER_ALL", "All")}
          </option>
          </select>*/}
        <DateFilter
          startDate={startDate}
          endDate={endDate}
          setEndDate={setEndDate}
          setStartDate={setStartDate}
          selectedDuration={selectedDuration}
        />
        <Select
          className="custom-select col-lg-2"
          classNamePrefix="custom-select"
          placeholder="Select"
          onChange={(val) => {
            handleStartDateCommon(
              val,
              setStartDate,
              setSelectedDuration,
              setEndDate
            );
          }}
          options={durationOptions}
          value={
            durationOptions?.find((item) => item?.value == selectedDuration) ||
            ""
          }
        />
        <span className="icon-wrap pt-cursor bg-gray-300">
          <i className="icon-filter" onClick={openModal} />
        </span>
      </div>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="v-middle">
                <div className="form-check">
                  <label className="form-check-label mt-1" htmlFor="taskName">
                    {getLangTranslation("WEB_ADDRESS", "Web address")}
                  </label>
                </div>
              </th>
              <th className="v-middle">
                {getLangTranslation("CATEGORY", "Category")}
              </th>
              <th className="v-middle">{getLangTranslation("DATE", "Date")}</th>
              <th className="v-middle">
                {getLangTranslation("DEVICE_DETAIL_ACTION", "Actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {webActivities?.map((item) => (
              <tr key={item?.ID}>
                <td
                  className="v-middle overflow-hidden"
                  style={{
                    maxHeight: "50px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "50vh",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`checkbox-${item?.ID}`}
                      checked={selectedItems.includes(item?.ID)}
                      onChange={() => handleCheckboxClick(item?.ID)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${item?.ID}`}
                    >
                      <div className="d-inline-flex  align-items-center">
                        <span className="icon-wrap icon-sm p-0 border-0 me-3 flex-shrink-0">
                          <img src={chromePic} alt="" />
                        </span>{" "}
                        {item?.websiteName}
                      </div>
                    </label>
                  </div>
                </td>
                <td className="v-middle">
                  {getLangTranslation("SOCIAL_APPS_COUNT", "Social media")}
                </td>
                <td className="v-middle text-nowrap">
                  {" "}
                  {moment(item?.visitTime).utc().format("MMM DD YYYY, hh:mm a")}
                </td>
                <td className="v-middle">
                  <div className="d-inline-flex align-items-center gap-6">
                    {item?.websiteStatus === 1 ? (
                      <>
                        <i className="icon-check-fill fs-5 text-blue-50  border rounded-circle" />
                        <i className="icon-ban fs-5 text-danger border-danger border rounded-circle" />
                      </>
                    ) : (
                      <>
                        <i className="icon-check-fill fs-5 text-success border rounded-circle border-success" />
                        <i className="icon-ban fs-5 text-blue-50 border rounded-circle" />
                      </>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {webActivities?.length === 0 && (
          <div className="text-center my-2 text-capitalize">
            -- {getLangTranslation("NO_DATA_LOG", "No data found")} --
          </div>
        )}
      </div>
    </>
  );
};

export default WebActivityScreen;
